import { render, staticRenderFns } from "./LoadingListItem.vue?vue&type=template&id=0ecde42c&"
import script from "./LoadingListItem.vue?vue&type=script&lang=ts&"
export * from "./LoadingListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports